import { getProjectInfo } from 'global-utils/get-attributes';
import { getPoliciesUrl } from 'global-utils/get-policies-url';
import { getPreferredLang } from 'global-utils/get-language';
import { getIsGdpr } from 'global-utils/get-is-gdpr';
import { FooterItem } from '../types';
import { buildFooterLabels } from './build-labels';

const manageCookiesUrl = '#cbg-manage-cookies';

export const buildItems = (
  translations: Record<string, string | { [key: string]: string }>
): FooterItem[] => {
  const { prjMarket, projectId } = getProjectInfo();
  const lang = getPreferredLang();
  const {
    policiesUrl,
    cookiesUrl,
    privacyUrl,
    termsUrl,
    acceptableUseUrl,
    socialMediaUrl,
    disclosurePolicyUrl,
    speakUpUrl
  } = getPoliciesUrl(lang, prjMarket, projectId);
  const isGdpr = getIsGdpr(prjMarket);
  const labels = buildFooterLabels(translations);

  const items: FooterItem[] = [
    {
      href: policiesUrl,
      label: labels.legalPolicies,
      id: 'cbg-link-policies'
    },
    {
      href: cookiesUrl,
      label: labels.cookies,
      id: 'cbg-link-cookies'
    }
  ];

  if (isGdpr) {
    items.push(
      {
        href: acceptableUseUrl,
        label: labels.acceptableUse,
        id: 'cbg-link-acceptable-use'
      },
      {
        href: termsUrl,
        label: labels.termsOfUse,
        id: 'cbg-link-terms'
      },
      {
        href: socialMediaUrl,
        label: labels.socialMedia,
        id: 'cbg-link-social-media'
      },
      {
        href: privacyUrl,
        label: labels.privacy,
        id: 'cbg-link-privacy'
      },
      {
        href: disclosurePolicyUrl,
        label: labels.disclosurePolicy,
        id: 'cbg-link-disclosure'
      }
    );
  }

  items.push(
    {
      href: manageCookiesUrl,
      label: labels.manageCookies,
      id: 'cbg-link-manage-cookies'
    },
    {
      href: speakUpUrl,
      label: labels.speakUp,
      id: 'cbg-link-speakUp'
    }
  );

  return items;
};
